<template>
  <div
    :class="{
      'px-1': true,
      'filter-panel-container': true,
      'filter-panel-container-mobile-view': isWindowSmall,
    }"
  >
    <div
      :class="{
        row: true,
        'container-sort-authority': true,
        'py-3': true,
        'border-bottom': !isWindowSmall,
      }"
    >
      <p style="font-family: oxygen-bold; color: var(--deepgreen)" class="mb-3">
        {{ filterReactionTitle }}
      </p>
      <!-- TODO: check sortArray function and implement again -->
      <div
        class="col-12"
        v-for="reaction in productReactions"
        :key="reaction.id"
      >
        <div class="d-flex form-check">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="reactionFilters"
            :value="Number(reaction.id)"
            @change="$emit('filtersUpdated')"
            :aria-labelledby="'myndighed-' + reaction.id"
            :id="'input-myndighed-' + reaction.id"
          />
          <label
            class="form-check-label"
            style="margin-left: 10px"
            :id="'myndighed-' + reaction.id"
            :for="'input-myndighed-' + reaction.id"
            >{{ reaction.name_d }}</label
          >
        </div>
      </div>
    </div>
    <div
      :class="{
        row: true,
        'container-sort-authority': true,
        'py-3': true,
        'border-bottom': !isWindowSmall,
      }"
    >
      <p style="font-family: oxygen-bold; color: var(--deepgreen)" class="mb-3">
        {{ filterCategoryTitle }}
      </p>
      <!-- TODO: check sortArray function and implement again -->
      <div
        class="col-12"
        v-for="category in productCategories"
        :key="category.id"
      >
        <div class="d-flex form-check">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="categoryFilters"
            :value="Number(category.id)"
            @change="$emit('filtersUpdated')"
            :aria-labelledby="'myndighed-' + category.id"
            :id="'input-myndighed-' + category.id"
          />
          <label
            class="form-check-label"
            style="margin-left: 10px"
            :id="'myndighed-' + category.id"
            :for="'input-myndighed-' + category.id"
            >{{ category.name_d }}</label
          >
        </div>
      </div>
    </div>
    <button
      v-if="!isWindowSmall"
      @click="clearFilters"
      @keyup.enter="clearFilters"
      class="btn btn-secondary my-4"
    >
      {{ clearFiltersTitle }}
    </button>
  </div>
</template>

<script>
export default {
  props: [
    "filterReactionTitle",
    "productReactions",
    "filterCategoryTitle",
    "productCategories",
    "isWindowSmall",
    "clearFiltersTitle",
  ],
  emits: ["filtersUpdated"],
  methods: {
    clearFilters() {
      if (
        this.$store.state.products.filtersInput.reactionFilters.length ||
        this.$store.state.products.filtersInput.categoryFilters.length
      ) {
        this.$store.commit("products/setReactionFilters", {
          reactionFilters: [],
        });
        this.$store.commit("products/setCategoryFilters", {
          categoryFilters: [],
        });
        this.$emit("filtersUpdated");
      }
    },
    sortArray(array) {
      //TODO: See https://stackoverflow.com/questions/29829205/sort-an-array-so-that-null-values-always-come-last for sorting when null is present in array
      return array.sort((a, b) => (a.name_d > b.name_d ? 1 : -1));
    },
  },
  computed: {
    reactionFilters: {
      get() {
        return this.$store.state.products.filtersInput.reactionFilters;
      },
      set(value) {
        this.$store.commit("products/setReactionFilters", {
          reactionFilters: value,
        });
      },
    },
    categoryFilters: {
      get() {
        return this.$store.state.products.filtersInput.categoryFilters;
      },
      set(value) {
        this.$store.commit("products/setCategoryFilters", {
          categoryFilters: value,
        });
      },
    },
  },
};
</script>

<style scoped lang="scss">
.form-check-input[type="checkbox"] {
  border-radius: 0 !important;
  &:focus {
    border-color: var(--lightgrey);
    box-shadow: 0 0 0 0.25em var(--mediumgreen);
  }
  &:checked {
    background-color: var(--deepgreen);
    border-color: var(--lightgrey);
    &:focus {
      box-shadow: 0 0 0 0.25em var(--mediumgreen);
    }
  }
}

.border-top {
  border-top: 2px solid var(--lightgrey) !important;
}
.border-bottom {
  border-bottom: 2px solid var(--lightgrey) !important;
}
.filter-panel-container-mobile-view {
  max-height: 60vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
